<template>
    <div>
        <p v-if="visible" class="bg-gradient-danger w-100 text-white p-1 pl-2 text-center" v-for="error in errors" v-html="error"></p>
    </div>
</template>

<script>
	export default {
		name: 'Error',
        props: [ 'visible', 'errors' ],
	};
</script>

